import { RootState } from '../types'

export const getMainAvailabilitySelector = (state: RootState) => state.availability
